import { ReactNode } from 'react';
import { cx } from './cx';
import { Text } from './Text';

export interface DescriptionItem {
  label: ReactNode;
  value: ReactNode;
}

export interface DescriptionListProps {
  items: DescriptionItem[];
  /** Lay out in 1 or 2 columns (responsive); default 2. */
  columns?: 1 | 2;
  className?: string;
}

/**
 * Key/value metadata list — the "About" pattern (owner, lifecycle, system,
 * tags…). Labels are quiet captions, values body text; composed from Text so
 * the type scale stays canonical.
 */
export const DescriptionList = ({
  items,
  columns = 2,
  className,
}: DescriptionListProps) => (
  <dl
    className={cx(
      'grid gap-x-6 gap-y-4',
      columns === 2 ? 'sm:grid-cols-2' : 'grid-cols-1',
      className,
    )}
  >
    {items.map((item, i) => (
      <div key={i} className="min-w-0">
        <Text variant="caption" tone="tertiary" as="dt" className="font-medium">
          {item.label}
        </Text>
        <Text variant="body" as="dd" className="mt-0.5">
          {item.value}
        </Text>
      </div>
    ))}
  </dl>
);
